/**
 * Action.ts
 * @author Diao Zheng
 * @file Action constructors and matchers
 * @barrel export all
 */
export const LegacyAction = Symbol.for("NLLegacyAction");
export function create(action, payload) {
    return { action, payload };
}
export function labelOnly(action) {
    return { action };
}
export function wrapString(action) {
    return { action, scope: LegacyAction };
}
export function rescope(action, scope) {
    return Object.assign(Object.assign({}, action), { scope });
}
export function isType(type) {
    return (action) => action.action === type;
}
export function isScope(scope) {
    return (action) => action.hasOwnProperty("scope") && action.scope === scope;
}
